import classnames from 'classnames/bind'
import React, { ReactNode } from 'react'

import { useStyle } from '~/providers/StyleProvider'

import { ReactComponent as ArrowIcon } from './arrow.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface FakeArrowLinkProps {
  className?: string
  hasArrow?: boolean
  children?: ReactNode
}

function FakeArrowLink({
  className,
  children,
  hasArrow = true,
}: FakeArrowLinkProps) {
  const ctaStyle = useStyle({ textPreset: 'cta-label', color: 'persian-blue' })

  return (
    <div className={cx(css.FakeArrowLink, ctaStyle, className)}>
      {children}
      {hasArrow && <ArrowIcon className={css.arrow} />}
    </div>
  )
}

FakeArrowLink.defaultProps = {}

export default FakeArrowLink
